"use strict";

var _toConsumableArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedCountryCode = exports.hasValidAddressInputs = exports.validateAddressInput = exports.getStateProvincesOptions = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime"); // Address Component

/**
 *  Address Component

 * @describe

 * supports languages fr, en, es
 * support countries us, cs, ca
 * performs validation after submit
 * performs pattern on zip codes after submit
 * labels change depending on country selected
 * languages changes based on language prop
 *
 * @sources
 *  Mexican Address Format
 * https://docs.informatica.com/data-as-a-service/address-verification-(on-premises)/h2l/address-verification-best-practices-for-mexico-addresses/mexico-addresses/address-format-and-address-structure.html
 * Canada
 * https://www.canadapost-postescanada.ca/tools/pg/manual/PGaddress-e.asp?ecid=murl10006450
 * Country RegExes:
 * https://gist.github.com/jamesbar2/1c677c22df8f21e869cca7e439fc3f5b
 */


var react_1 = require("react");

var __1 = require("..");

var content_1 = require("./content");

var __2 = require("..");

var Models_1 = require("./Models");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var react_2 = require("@emotion/react");

var frontend_common_2 = require("@ryerson/frontend.common");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var addInputMargin = (0, react_2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin-bottom: 10px;\n"])));
var addLabelInputMargin = (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tmargin-bottom: 17px;\n"])));
var fullWidth = (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 100%;\n"])));
var zipCodeWidth = (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\twidth: 30%;\n"])));
var countryStyle = (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tmargin-bottom: 17px;\n"])));

var stateStyle = function stateStyle(props) {
  return (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tmargin-right: ", ";\n\tmargin-bottom: ", ";\n"])), props.isMobile ? "" : "10px", props.isMobile ? "17px" : "");
};

var cityInputValidationPattern = "^[a-zA-Z]+([ -][a-zA-Z]+)*$";

var Address = function Address(_ref) {
  var inputValues = _ref.inputValues,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      handleChange = _ref.handleChange,
      _ref$submitted = _ref.submitted,
      submitted = _ref$submitted === void 0 ? false : _ref$submitted,
      language = _ref.language,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      type = _ref.type,
      shape = _ref.shape,
      maxLength = _ref.maxLength,
      isMobile = _ref.isMobile,
      name = _ref.name,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? true : _ref$required,
      sizeMobile = _ref.sizeMobile;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _ref3 = (0, frontend_common_2.useWindowSize)(),
      _ref4 = _slicedToArray(_ref3, 1),
      width = _ref4[0];

  sizeMobile && width < parseInt(theme.breakpoints.lg) && (size = sizeMobile);

  var getLabel = function getLabel(key) {
    var country = inputValues.country;
    var lang = content_1.withTranslation[language];
    var langCountry = Object.keys(lang).indexOf(country) > -1 && Object.keys(lang[country]).indexOf(key) > -1 ? lang[country] : lang.us;
    return langCountry && langCountry[key];
  };

  var isValid = function isValid(key, value, required) {
    var country = inputValues.country;
    if (!required) return true;
    return (0, exports.validateAddressInput)(key, value, country);
  };

  var isRequired = function isRequired(key) {
    return Object.values(Models_1.RequiredInputs).indexOf(key) > -1;
  };

  var _ref5 = (0, react_1.useState)(Object.keys(Models_1.Countries).map(function (key) {
    return {
      value: key,
      display: Models_1.CountryDisplay[key]
    };
  })),
      _ref6 = _slicedToArray(_ref5, 1),
      countryOptions = _ref6[0];

  var fieldValidation = function fieldValidation(key, value) {
    var updatedCountryCode = (0, exports.getSelectedCountryCode)(inputValues.country);

    if (key === "stateProvince" && submitted && !(0, exports.getStateProvincesOptions)(updatedCountryCode).find(function (option) {
      return option.value === value;
    })) {
      return frontend_common_1.CONSTANTS[language].REQUIRED_FIELD;
    }

    return "";
  };

  var getFieldPatterns = function getFieldPatterns(key) {
    if (key === Models_1.RequiredInputs.zipPostal) {
      var updatedCountryCode = (0, exports.getSelectedCountryCode)(inputValues.country);
      return frontend_common_2.PostalCodeRegexPatterns[updatedCountryCode];
    }

    if (key === Models_1.RequiredInputs.city) {
      return cityInputValidationPattern;
    }

    return undefined;
  };

  var drawDropdown = function drawDropdown(key, options) {
    return (0, jsx_runtime_1.jsx)(__2.Dropdown, {
      disabled: disabled,
      name: key,
      id: key,
      autoComplete: "on",
      required: isRequired(key),
      value: inputValues[key],
      onChange: function onChange(val) {
        handleChange(val, key);
      },
      options: options,
      label: getLabel(key),
      type: type,
      size: size,
      language: language,
      isValid: required && submitted ? isValid(key, inputValues[key], isRequired(key)) : true,
      validation: function validation(value) {
        return fieldValidation(key, value);
      }
    });
  };

  var drawInput = function drawInput(key, label, required) {
    return (0, jsx_runtime_1.jsx)(__1.Input, {
      language: language,
      onChange: function onChange(e) {
        return handleChange(e.target.value.replace(frontend_common_2.PostalCodeRegexPatterns.whiteSpace, ""), key);
      },
      required: required,
      name: key,
      label: label,
      value: inputValues[key],
      maxLength: key === "zipPostal" ? frontend_common_2.ZIPCODE_CHAR_LIMIT[inputValues.country] : maxLength,
      size: "".concat(size),
      type: type,
      shape: shape,
      disabled: disabled,
      isValid: required && submitted ? isValid(key, inputValues[key], required) : true,
      submitted: submitted,
      pattern: submitted ? getFieldPatterns(key) : undefined,
      sizeMobile: sizeMobile
    });
  };

  return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
    direction: "column",
    className: "".concat(name ? name + "-" : "address-", "component-root"),
    style: fullWidth,
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      style: countryStyle,
      children: drawDropdown("country", countryOptions)
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      style: addInputMargin,
      direction: "column",
      children: drawInput("streetAddressOne", getLabel("streetAddressOne"), isRequired("streetAddressOne"))
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      style: addLabelInputMargin,
      direction: "column",
      children: drawInput("streetAddressTwo", "", isRequired("streetAddressTwo"))
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      style: addLabelInputMargin,
      direction: "column",
      children: drawInput("city", getLabel("city"), isRequired("city"))
    }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      className: "state-and-zip",
      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        style: stateStyle({
          isMobile: isMobile
        }),
        children: drawDropdown("stateProvince", (0, exports.getStateProvincesOptions)(inputValues.country))
      }), !isMobile && (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        style: zipCodeWidth,
        children: drawInput("zipPostal", getLabel("zipPostal"), isRequired("zipPostal"))
      })]
    }), isMobile && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      style: fullWidth,
      direction: "column",
      children: drawInput("zipPostal", getLabel("zipPostal"), isRequired("zipPostal"))
    })]
  });
};

var getStateProvincesOptions = function getStateProvincesOptions(country) {
  var defaultOption = {
    value: "",
    display: ""
  };

  if (country === "ca") {
    var caProvinceOptions = [defaultOption].concat(_toConsumableArray(Object.keys(Models_1.CAProvinces).map(function (key) {
      return {
        value: key,
        display: Models_1.CAProvincesDisplay[key]
      };
    })));
    return caProvinceOptions;
  } else if (country === "mx") {
    var mxProvinceOptions = [defaultOption].concat(_toConsumableArray(Object.keys(Models_1.MXProvices).map(function (key) {
      return {
        value: key,
        display: Models_1.MXProvincesDisplay[key]
      };
    })));
    return mxProvinceOptions;
  } else {
    var usStateOptions = [defaultOption].concat(_toConsumableArray(Object.keys(Models_1.USStates).map(function (key) {
      return {
        value: key,
        display: Models_1.USStatesDisplay[key]
      };
    })));
    return usStateOptions;
  }
};

exports.getStateProvincesOptions = getStateProvincesOptions;

var validateAddressInput = function validateAddressInput(key, value, country) {
  var valid = !!(value === null || value === void 0 ? void 0 : value.trim());
  var updatedCountryCode = (0, exports.getSelectedCountryCode)(country);

  if (key === Models_1.RequiredInputs.zipPostal) {
    var regex = new RegExp(frontend_common_2.PostalCodeRegexPatterns[updatedCountryCode]);
    valid = regex.test(value);
  }

  if (key === Models_1.RequiredInputs.stateProvince) {
    var stateOptions = (0, exports.getStateProvincesOptions)(updatedCountryCode);
    valid = value && !!stateOptions.find(function (option) {
      return option.value === value;
    });
  }

  if (key === Models_1.RequiredInputs.city) {
    var _regex = new RegExp(cityInputValidationPattern);

    valid = value && _regex.test(value);
  }

  return valid;
};

exports.validateAddressInput = validateAddressInput;

var hasValidAddressInputs = function hasValidAddressInputs(inputValues) {
  var country = inputValues.country,
      streetAddressOne = inputValues.streetAddressOne,
      city = inputValues.city,
      stateProvince = inputValues.stateProvince,
      zipPostal = inputValues.zipPostal;
  var updatedCountryCode = (0, exports.getSelectedCountryCode)(country);
  var hasValidInputs = true;

  if (!updatedCountryCode || !streetAddressOne.trim() || !city.trim() || !stateProvince || !zipPostal.trim()) {
    return false;
  }

  if (hasValidInputs && updatedCountryCode && stateProvince) {
    var stateOptions = (0, exports.getStateProvincesOptions)(updatedCountryCode);
    hasValidInputs = !!stateOptions.find(function (option) {
      return option.value === stateProvince;
    });
  }

  if (hasValidInputs && zipPostal) {
    var regex = new RegExp(frontend_common_2.PostalCodeRegexPatterns[updatedCountryCode]);
    hasValidInputs = regex.test(zipPostal);
  }

  if (hasValidInputs && city) {
    var _regex2 = new RegExp(cityInputValidationPattern);

    hasValidInputs = _regex2.test(city);
  }

  return hasValidInputs;
};

exports.hasValidAddressInputs = hasValidAddressInputs; // This function return 2 character country code when address component country value was set to 3 character country code

var getSelectedCountryCode = function getSelectedCountryCode(country) {
  switch (country.toLowerCase()) {
    case "usa":
      return frontend_common_1.Country.us;

    case "can":
      return frontend_common_1.Country.ca;

    case "mex":
      return frontend_common_1.Country.mx;

    default:
      return country;
  }
};

exports.getSelectedCountryCode = getSelectedCountryCode;
Address.displayName = "Address";
exports.default = Address;